import { useState } from "react";
import styled from "styled-components";
import LessonAssign from "./LessonAssign";
import LessonManage from "./LessonManage";
import { useLocation } from "react-router-dom";
import { hw } from "features/homework/homeworkUi";

const LessonAssignManage = () => {
    const nav = useLocation().state;
    const [clickedNav, setClickedNav] = useState(nav || "학급관리");

    return (
        <Page>
            <PageHeader>
                <div>
                    <Title>학급 설정</Title>
                    <Desc>학급을 등록하거나 원생을 배정합니다.</Desc>
                </div>
            </PageHeader>
            <Tabs>
                {["학급관리", "학급배정"].map((name) => (
                    <Tab
                        key={name}
                        type="button"
                        $on={clickedNav === name}
                        onClick={() => setClickedNav(name)}
                    >
                        {name}
                    </Tab>
                ))}
            </Tabs>
            <Body>
                {clickedNav === "학급관리" ? <LessonManage /> : <LessonAssign />}
            </Body>
        </Page>
    );
};

const Page = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 20px 24px;
    width: 100%;
    box-sizing: border-box;
`;

const PageHeader = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px 16px;
    flex-shrink: 0;
`;

const Title = styled.h1`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: ${hw.text};
`;

const Desc = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${hw.textMuted};
`;

const Tabs = styled.div`
    display: flex;
    gap: 4px;
    border-bottom: 1px solid ${hw.border};
    flex-shrink: 0;
`;

const Tab = styled.button<{ $on: boolean }>`
    appearance: none;
    border: none;
    background: transparent;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 700;
    color: ${props => props.$on ? hw.brand : hw.textMuted};
    border-bottom: 2px solid ${props => props.$on ? hw.brand : "transparent"};
    margin-bottom: -1px;
    cursor: pointer;

    &:hover {
        color: ${props => props.$on ? hw.brand : hw.text};
    }
`;

const Body = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    min-width: 0;
`;

export default LessonAssignManage;
